@if(printerData(); as data) {
    <app-main-base [useGrid]="false"
        [isMobile]="isMobile"
        (back)="goBack()">
        
        <div mainTitle class="tw-w-full tw-min-w-0">
            <span class="tw-w-full" [appTruncatedText]="printerFormService.printerName?.value || ''"
            >{{ printerFormService.printerName?.value }}</span>
        </div>
    
        <ng-container mainActions>
            @if(actions.showDelete) {
                <app-action-btn (click)="deletePrinter()"
                    variant="basic">
                    {{ 'PRINTERS.DETAIL.DELETE' | translate }}
                </app-action-btn>
            }
            @if(actions.showSave) {
                <app-action-btn (click)="save()">
                    {{ 'PRINTERS.DETAIL.SAVE' | translate }}
                </app-action-btn>
            }
            @if(actions.showConfigure) {
                <app-action-btn (click)="configure()">
                    {{ 'PRINTERS.DETAIL.CONFIGURE' | translate }}
                </app-action-btn>
            }
        </ng-container>
    
        <div mainHeaderExtra>
            <nav mat-tab-nav-bar [tabPanel]="tabPanel" color="primary">
                @for (tab of visibleTabs(); track tab.id) {
                    <a mat-tab-link 
                        (click)="changeTab(tab.id)" 
                        [active]="activeTab() === tab.id">
                        {{ tab.label | translate }}
                    </a>
                }
            </nav>
        </div>
    
        <div mainBody>
            <mat-tab-nav-panel #tabPanel>
                <div #tabContent class="tw-grid tw-w-full tw-gap-4 tw-items-start tw-pb-1"
                    [ngClass]="isMobile ? 'tw-grid-cols-1' : 'lg:tw-grid-cols-2'">
                    
                    @switch (activeTab()) {
                        @case ('operations') {
                            <app-printer-operations />
                        }
                        @case ('non_fiscal_configuration') {
                            <app-printer-non-fiscal-configuration />
                        }
                        @case ('settings') {
                            <app-printer-settings />
                        }
                        @case ('configuration') {
                            <app-printer-configuration />
                        }
                        @case ('stub') {
                            <app-printer-stub />
                        }
                    }
                </div>
            </mat-tab-nav-panel>
        </div>
    </app-main-base>
}
